import { Part } from '../types';

export const PARTS_DATA: Part[] = [
  {
    id: 1,
    name: 'Écran iPhone 15 Pro Max',
    brand: 'Apple',
    price: 199,
    stock: 10,
    quality: 'Original',
    // Empty media intentionally delegates to the governed local SVG fallback.
    // A demo CDN must never become a public runtime dependency.
    image: '',
    mainCategory: 'Pièces détachées',
    productType: 'Écran',
    catalogKind: 'ACCESSORY',
    sku: 'PART-SCREEN-IP15PM',
    description: 'Écran de remplacement pour iPhone 15 Pro Max.'
  }
];
